import React from 'react';
import FontAwesome from 'react-fontawesome';
import { Trans } from 'lingui-react';
import { P } from 'base-components';

import Wrapper from './Wrapper';

import messages from '../messages';

function SelectedLabel() {
  return (
    <Wrapper>
      <FontAwesome name="check-circle" />
      <P modifiers={['fontWeightLight', 'textLight', 'uppercase']}>
        <Trans id={messages.selected} />
      </P>
    </Wrapper>
  );
}

export default SelectedLabel;



// WEBPACK FOOTER //
// ./components/ServiceProvidersList/SelectedLabel/index.js